// In-App 메시지 템플릿 한국어 번역 (템플릿 id 기준, 관리자 확인용)
export const messageTemplatesKo = {
  consultation_welcome: { title: '🩺 전문가 상담 서비스', body: '궁금한 점이 있으신가요? 전문가와 상담해 보세요.', action: '상담 시작하기' },
  consultation_reminder: { title: '🩺 상담 서비스를 이용해 보세요', body: '직장 관련 문제나 건강에 대한 질문이 있으신가요?', action: '상담 시작하기' },
  consultation_success: { title: '✅ 상담이 완료되었습니다', body: '전문가가 회원님의 질문에 답변했습니다.', action: '답변 보기' },
  consultation_health: { title: '🏥 건강 상담', body: '건강과 관련된 질문이 있으신가요?', action: '건강 상담 시작하기' },
  consultation_work: { title: '💼 직장 관련 상담', body: '직장에서 겪는 문제를 상담해 보세요.', action: '직장 상담 시작하기' },
  consultation_legal: { title: '⚖️ 법률 상담', body: '한국 법률과 관련된 질문이 있으신가요?', action: '법률 상담 시작하기' },
  consultation_emergency: { title: '🚨 긴급 상담', body: '긴급한 상황에서 상담이 필요하신가요?', action: '긴급 상담 시작하기' },

  community_welcome: { title: '👥 커뮤니티 센터', body: '같은 지역·업종의 미얀마 근로자들과 소통해 보세요.', action: '커뮤니티 센터 입장' },
  community_activity: { title: '👥 커뮤니티 센터 활동', body: '회원님 지역에서 활동이 진행 중입니다. 참여해 보세요.', action: '커뮤니티 센터 입장' },
  community_new_post: { title: '📝 커뮤니티 센터 새 게시글', body: '회원님 지역에 새 게시글이 올라왔습니다. 확인해 보세요.', action: '게시글 보기' },
  community_job_sharing: { title: '💼 일자리 정보 공유', body: '회원님 지역에서 일자리 정보가 공유되고 있습니다.', action: '일자리 정보 보기' },
  community_housing: { title: '🏠 집 구하기', body: '회원님 지역에서 집을 구하는 사람들이 있습니다.', action: '집 구하기 보기' },
  community_event: { title: '🎉 축제 및 행사', body: '회원님 지역에서 축제와 행사가 열리고 있습니다.', action: '행사 보기' },
  community_help: { title: '🤝 도움 요청', body: '회원님 지역에서 도움을 요청하는 사람들이 있습니다.', action: '도움 요청 보기' },

  news_breaking: { title: '📰 주요 뉴스', body: '미얀마와 한국의 주요 뉴스가 있습니다.', action: '뉴스 보기' },
  news_daily: { title: '📰 오늘의 뉴스', body: '미얀마와 한국의 오늘 뉴스를 확인해 보세요.', action: '뉴스 보기' },

  remittance_welcome: { title: '💰 송금 서비스', body: '가족에게 안전하게 송금하세요.', action: '송금하기' },
  remittance_promotion: { title: '🎉 송금 할인', body: '이번 주 송금 수수료 50% 할인 혜택을 받을 수 있습니다.', action: '송금하기' },
  remittance_completed: { title: '✅ 송금이 완료되었습니다', body: '회원님의 송금이 성공적으로 완료되었습니다.', action: '송금 내역 보기' },
  remittance_reminder: { title: '💰 송금 알림', body: '가족에게 송금하는 것을 잊지 마세요.', action: '송금하기' },
  myanmar_story_welcome: { title: '📖 미얀마 이야기', body: '미얀마의 문화, 전통과 이야기를 읽어 보세요.', action: '미얀마 이야기 읽기' },
  myanmar_story_new: { title: '📖 새로운 미얀마 이야기', body: '새로운 미얀마 이야기가 올라왔습니다. 읽어 보세요.', action: '이야기 읽기' },

  messaging_welcome: { title: '💬 메시지 보내기', body: '친구들에게 메시지를 보내 보세요.', action: '메시지 보내기' },
  messaging_new_message: { title: '💬 새 메시지', body: '새 메시지가 도착했습니다.', action: '메시지 보기' },

  encouragement_daily: { title: '🌅 좋은 하루 되세요', body: '오늘도 좋은 하루 되세요. 저희 서비스를 이용해 보세요.', action: '서비스 보기' },
  encouragement_weekend: { title: '🎉 즐거운 주말 되세요', body: '주말에 푹 쉬시고 가족과 연락해 보세요.', action: '서비스 보기' },
  encouragement_holiday: { title: '🎊 즐거운 명절 되세요', body: '미얀마 명절을 즐겁게 보내세요.', action: '서비스 보기' },

  urgent_system: { title: '⚠️ 시스템 점검', body: '시스템 점검으로 서비스가 일시 중단되었습니다.', action: '자세히 보기' },
  urgent_security: { title: '🔒 보안 경고', body: '회원님 계정의 보안과 관련된 경고가 있습니다.', action: '보안 점검하기' },

  kyc_reminder: { title: '📋 KYC 인증이 필요합니다', body: '계정 인증을 위해 KYC 절차가 필요합니다.', action: 'KYC 인증 시작하기' },
  kyc_urgent_reminder: { title: '🚨 KYC 인증이 필요합니다', body: '계정 보안을 위해 KYC 인증이 필요합니다. 미얀마 노동부의 요구사항입니다.', action: 'KYC 인증 시작하기' },
  kyc_approved: { title: '✅ KYC 인증 완료', body: '회원님의 KYC 인증이 성공적으로 완료되었습니다.', action: '계정 확인하기' },
  kyc_rejected: { title: '❌ KYC 인증 재확인 필요', body: '회원님의 KYC 인증을 다시 확인해야 합니다.', action: 'KYC 다시 시작하기' },

  embassy_visa: { title: '🛂 비자 신청', body: '비자 신청 관련 서비스를 이용할 수 있습니다.', action: '비자 서비스 보기' },
  embassy_passport: { title: '📘 여권 신청', body: '여권 신청 관련 서비스를 이용할 수 있습니다.', action: '여권 서비스 보기' },
  embassy_document: { title: '📄 서류 인증', body: '서류 인증 관련 서비스를 이용할 수 있습니다.', action: '서류 서비스 보기' },

  education_korean: { title: '🇰🇷 한국어 배우기', body: '한국어 학습 관련 서비스를 이용할 수 있습니다.', action: '한국어 배우기' },
  education_skill: { title: '🎓 직무 기술 배우기', body: '직무 관련 기술 학습 서비스를 이용할 수 있습니다.', action: '기술 배우기' },
  education_certificate: { title: '🏆 자격증 취득', body: '직무 관련 자격증 취득 서비스를 이용할 수 있습니다.', action: '자격증 취득하기' },

  lifestyle_weather: { title: '🌤️ 날씨 정보', body: '한국의 날씨 정보를 확인해 보세요.', action: '날씨 정보 보기' },
  lifestyle_transport: { title: '🚌 교통 정보', body: '한국의 교통 정보를 확인해 보세요.', action: '교통 정보 보기' },
  lifestyle_shopping: { title: '🛒 쇼핑 정보', body: '한국의 쇼핑 정보를 확인해 보세요.', action: '쇼핑 정보 보기' },
  lifestyle_food: { title: '🍜 미얀마 음식점', body: '한국에 있는 미얀마 음식점을 찾아보세요.', action: '미얀마 음식점 보기' },

  promotion_discount: { title: '🎉 할인 프로모션', body: '특별 할인 프로모션을 이용할 수 있습니다.', action: '할인 프로모션 보기' },
  promotion_event: { title: '🎊 특별 행사', body: '미얀마 축제와 특별 행사가 열리고 있습니다.', action: '행사 보기' },
  promotion_reward: { title: '🎁 리워드 받기', body: '회원님을 위한 리워드를 받을 수 있습니다.', action: '리워드 받기' },

  policy_compliance_reminder: { title: '💝 가족에게 송금하세요', body: '가족이 안심할 수 있도록 송금해 주세요. 정책 준수율도 유지할 수 있습니다.', action: '송금하기' },
  policy_compliance_urgent: { title: '🚨 정책 준수 긴급 안내', body: '정책 준수율이 매우 낮습니다. 미얀마 노동부로부터 불이익을 받을 수 있습니다.', action: '지금 바로 송금하기' },
  employment_data_required: { title: '📋 고용 상태 입력이 필요합니다', body: '정책 준수 관리를 위해 고용 상태를 입력해 주세요.', action: '고용 상태 입력하기' },
  policy_compliance_achieved: { title: '✅ 정책 준수 달성', body: '축하합니다! 정책 준수율 100%를 달성했습니다.', action: '송금 내역 확인하기' },
};

/**
 * 메시지/템플릿의 한국어 번역을 반환합니다.
 * 메시지에 저장된 titleKo/bodyKo가 우선이며, 템플릿 원문을 수정하지 않은 경우에만 템플릿 번역을 사용합니다.
 */
export const getKoreanContent = (item, sourceTemplate = null) => {
  if (!item) return null;
  if (item.titleKo || item.bodyKo) {
    return { title: item.titleKo || '', body: item.bodyKo || '', action: item.actionKo || '' };
  }
  const templateKey = item.templateId || item.id;
  const ko = messageTemplatesKo[templateKey];
  if (!ko) return null;
  if (sourceTemplate && (sourceTemplate.title !== item.title || sourceTemplate.body !== item.body)) {
    return null;
  }
  return ko;
};
